import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import LineItem from '../LineItem/LineItem';
import { sortItemsByAddedAt, getCustomAttributeTextField } from '../../Utils/CartUtils';
import { StyledTitle, StyledSubTitle } from '../LineItemList/LineItemListStyles';

var LineItemListAlt = function LineItemListAlt(props) {
  return props.items.length > 0 ? React.createElement(
    Fragment,
    null,
    React.createElement(
      StyledTitle,
      null,
      props.title
    ),
    window.Dormify.shipLaterEnabled && React.createElement(
      StyledSubTitle,
      null,
      props.subTitle
    ),
    React.createElement(
      'ul',
      null,
      sortItemsByAddedAt(props.items).map(function (item) {
        var customAttributeText = getCustomAttributeTextField(item.node);
        var key = customAttributeText ? item.node.id + '-' + customAttributeText : '' + item.node.id;
        return React.createElement(LineItem, {
          removeLineItemInCart: props.removeLineItemInCart,
          updateLineItemInCart: props.updateLineItemInCart,
          key: key,
          lineItem: item.node
        });
      })
    )
  ) : null;
};

LineItemListAlt.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  updateLineItemInCart: PropTypes.func.isRequired,
  removeLineItemInCart: PropTypes.func.isRequired
};

export default LineItemListAlt;